import { CapoPlugin } from "/builds/webcontact/burgbernheim/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];